/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { Group, Text } from '@mantine/core'
import FormStateBadge from './FormStateBadge'

export type RecordMetasProps = {
  metas: {
    createdAt?: string,
    createdBy?: string,
    modifiedAt?: string,
    archivedAt?: string,
  }
}

function RecordMetas (props: RecordMetasProps) {
  const intl = useIntl()
  const { metas } = props

  const infos = useMemo(
    () => (
      [
        metas.createdAt != null && metas.createdBy != null
          ? intl.formatMessage({
            id: 'created_at_by.datetime',
            defaultMessage: 'Créé le {date} à {time} par {username}'
          }, {
            date: intl.formatDate(metas.createdAt),
            time: intl.formatTime(metas.createdAt),
            username: metas.createdBy
          })
          : null,

        metas.createdAt != null && metas.createdBy == null
          ? intl.formatMessage({
            id: 'created_at.datetime',
            defaultMessage: 'Créé le {date} à {time}'
          }, {
            date: intl.formatDate(metas.createdAt),
            time: intl.formatTime(metas.createdAt)
          })
          : null,

        metas.modifiedAt != null
          ? intl.formatMessage({
            id: 'modified_at.datetime',
            defaultMessage: 'Modifié le {date} à {time}'
          }, {
            date: intl.formatDate(metas.modifiedAt),
            time: intl.formatTime(metas.modifiedAt)
          })
          : null,

        metas.archivedAt != null
          ? intl.formatMessage({
            id: 'archived_at.datetime',
            defaultMessage: 'Archivé le {date} à {time}'
          }, {
            date: intl.formatDate(metas.archivedAt),
            time: intl.formatTime(metas.archivedAt)
          })
          : null
      ]
        .filter((m) => m !== null)
    ),
    [
      intl,
      metas.archivedAt,
      metas.createdAt,
      metas.createdBy,
      metas.modifiedAt
    ])

  if (infos.length === 0) {
    return null
  }

  return (
    <Group>
      {infos.map((meta) => (
        <Text size="sm" c="dimmed" key={meta}>
          {meta}
        </Text>
      ))}
      <FormStateBadge />
    </Group>
  )
}

export default RecordMetas
